export default "<img src=\"{{flagFilePath}}\" class=\"lang\" (click)=\"onClick()\">\n"